module.exports = __webpack_public_path__ + "img/shrink-enlarge-minus.662eb66a.svg";